import {Box} from "@mui/system";
import _ from "lodash";
import {parseHtml} from "_helpers";
import {extractMedia, metaMediaType} from "../../../../utilities/MetaUtils";
import FacebookImageCard from "./FacebookImageCard";
import FacebookGifCard from "./FacebookGifCard";
import FacebookVideoCard from "./FacebookVideoCard";

export default function FacebookContent({text, sourceName}) {

    const Content = () => {
        return (
            <Box>
                { parseHtml(text, sourceName) }
            </Box>
        )
    }

    const mediaObj = extractMedia(text);
    const mediaId = _.get(mediaObj, 'id');
    const mediaType = _.get(mediaObj, 'type');

    switch (mediaType) {
        case metaMediaType.GIF:
            return <FacebookGifCard gifId={mediaId} />;

        case metaMediaType.PHOTO:
            return <FacebookImageCard photoId={mediaId} />;

        case metaMediaType.VIDEO:
            return <FacebookVideoCard videoId={mediaId} />;

        default:
            return <Content />;
    }
}